import React, {useCallback, useEffect} from 'react';
export const useEffectKeys = ({subSequence, setSelectedPadEdge, selectedElements}) => {
    useEffect(() => {
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [subSequence]);

    const onKeyDown = useCallback((e) => {
        if (e.target.tagName === 'INPUT' ||
            e.target.tagName === 'TEXTAREA') {
            return;
        }

        if (e.key === "Backspace") {
            let {sequencerEngine} = subSequence;
            let {selectedEdge} = sequencerEngine.state.pads;
            let {selectedElements} = sequencerEngine.state.windows;
            for (let id in selectedElements) {
                let node = subSequence.sequencerEngine.findNodeById(id);
                if (node && node.subSequence === subSequence) {
                    if (node.isDeletable && !node.isDeletable()) {
                    } else {
                        if (node.delete) {
                            node.delete();
                        } else {
                            subSequence.deleteNode(node);
                        }
                    }
                }
            }

            if (selectedEdge) {
                if (selectedEdge.inlet) {
                    // then its a message edge
                    let {inlet, outlet} = selectedEdge;
                    let toEffect = subSequence.sequencerEngine.findNodeById(outlet.destId);
                    let fromEffect = subSequence.sequencerEngine.findNodeById(outlet.sourceId);
                    if (toEffect && fromEffect) {
                        toEffect.disconnectInlet(outlet.destType, fromEffect, outlet.sourceType);
                    }
                } else {
                    let pad = subSequence.pads.find(
                        pad => pad.effectRack.effects.includes(selectedEdge.effect) ||
                            pad.effectRack.outputNode === selectedEdge.effect);
                    if (!pad) {
                        // look for track
                        pad = subSequence.tracks.find(
                            track => track.effectRack &&
                                (track.effectRack.effects.includes(selectedEdge.effect) ||
                                 track.effectRack.outputNode === selectedEdge.effect));
                    }
                    pad.effectRack.deleteEdge(selectedEdge);
                }
                setSelectedPadEdge(undefined);
            }
        }
    }, [subSequence]);
};
